export enum SocketTopics  {
  SurveyTopics= 'surveyTopics',
  SubscribePageTopics= 'subscribePageTopics',
  UnSubscribePageTopics= 'unSubscribePageTopics',
  PublishPageTopics= 'publishPageTopics',
}

export enum SurveyQuestionTopics {
  GetSurveys = 'getSurveys',
  GetSurveyQuestions = 'getSurveyQuestions',
  UpdateSurveyQuestion = 'updateSurveyQuestion',
  DeleteSurveyQuestion = 'deleteSurveyQuestion',
  createSurveyQuestion = 'createSurveyQuestion'
}

export enum ProjectTopics {
  GetOneProject = 'getOneProject'
}

export enum CADSectionTopics {
    GetSectionList = 'getSectionList',
    UpdateSectionList = 'updateSectionList'
}

export enum BioTopics {
  UpdateBioList = 'updateBioList',

  GetBio = 'getBio',
  GetRoleList = 'getRoleList'
}

export enum CalendarTopics {
  GetCalendarSetting = 'getCalendarSetting',
}

// refactor it
export enum ExtendedBioTopics {
  GetRolesBio = 'getRolesBio',
  UpdateRoleBio = 'updateRolesBio',
  GetUserBio = 'getUserBio',
  UpdateUserBio = 'updateUserBio',
  GetVehicleBio = 'getVehicleBio'
}

export enum UserTopics {
    SearchInUser = 'searchInUser',
    UpdateUser = 'updateUser'
}

export enum ModalType {
  Survey = 'survey',
  ExtendedBio = 'extendedBio',
  Vehicle = 'vehicle'
}

export enum QuestionaireType {
  YesNo = 'yes-no',
  MultipleChoice = 'multiple-choice',
  DropDown = 'dropDown',
  Bar = 'bar',
  Number = 'number',
  Date = 'date',
  Time = 'time',
  Text = 'text',
  ThreeButton = '3-button',
  Currency = 'currency',
  DateTime = 'date-time',
  Media = 'media',
  Capture = 'capture',
  Phone = 'phone',
  Email = 'email',
  Name = 'name',
  File = 'file',
  Signature = 'signature',
  Tag="tag",
  TagNot = "TagNot",
  GPS = "GPS",
  Location="location",
  Project="project",
  Search="search",
  IncidentLocation="incident-location",
  TaskPicker="task-picker",
  EventName="event-name",
  Event="event",
  FixedAsset="fixed-asset",
  Responder="responder",
  Schedule="schedule",
  Customer="customer-search",
  DispatchType="dispatchType",
}

export enum PageTopics {
  GetProjectsResult= 'getProjects/reply',
  GetAccountsResult= 'getAccounts/reply',
  GetRespondersResult= 'getResponders/reply',
  GetAssetsResult= 'getAssets/reply',
  CreateEventResult= 'createEventPage/reply',
  CreateTicketResult= 'createTicketPage/reply',
  CreateRideResult= 'createRideRequest/reply',
  SearchPageResult= 'searchInPage/reply',
  BdsEot= 'bdsEot',
  SearchUser= 'searchUser',
  SearchMessage= 'searchMessage',
  GroupMembers= 'group/members',
  SearchBds='searchBds/reply',
  GetPageAggregateBds='getPageAggregateBds/reply',
  GetPageResult='searchPage/reply',
  GetAggregateBds='aggregateBds/reply',
  Connection='connection',
}